"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var VehicleEntity_1 = __importDefault(require("./Entity/VehicleEntity"));
var Vehicle_consts_1 = require("./Vehicle.consts");
var Vehicles = /** @class */ (function () {
    function Vehicles(session) {
        this.vehicleEntity = new VehicleEntity_1.default(session);
        this.onUpdate = this.vehicleEntity.store.onItemUpdate;
        this.onDelete = this.vehicleEntity.store.onItemRemoved;
        this.onCreate = this.vehicleEntity.store.onItemCreated;
        this.onVehicleUnassigned = this.vehicleEntity.onVehicleUnassigned;
        this.unsubscribe = this.vehicleEntity.store.unsubscribe;
    }
    Vehicles.prototype.getAll = function () {
        return this.vehicleEntity.getAll();
    };
    Vehicles.prototype.getAllByTeam = function (teamId) {
        return this.vehicleEntity.getAllByTeam(teamId);
    };
    Vehicles.prototype.get = function (id) {
        return this.vehicleEntity.get(id);
    };
    Vehicles.prototype.update = function (id, diff) {
        return this.vehicleEntity.update(id, diff, Vehicle_consts_1.vehicleExtractor, Vehicle_consts_1.vehicleExtractor);
    };
    Vehicles.prototype.create = function (vehicle) {
        return this.vehicleEntity.create(vehicle, Vehicle_consts_1.vehicleExtractor, Vehicle_consts_1.vehicleExtractor);
    };
    Vehicles.prototype.delete = function (id) {
        return this.vehicleEntity.delete(id);
    };
    Vehicles.prototype.getAssignmentHistory = function (id) {
        return this.vehicleEntity.getAssignmentHistory(id);
    };
    Vehicles.prototype.importVehiclesCsv = function (file) {
        return this.vehicleEntity.importVehiclesCsv(file);
    };
    Vehicles.prototype.getCsvUploadFields = function () {
        return this.vehicleEntity.getCsvUploadFields();
    };
    return Vehicles;
}());
exports.default = Vehicles;
//# sourceMappingURL=VehicleApi.js.map